export const ICON_FAMILY_DEFAULT = "default";
export const ICON_HEIGHT = 24;
export const ICON_WIDTH = 24;
